/**
 * Regicide trump + rank-direction indicator. Uses the shared compact
 * TrumpBadge — small footprint so it doesn't cover the core/up-card
 * widget on mobile.
 *
 * Direction semantics for the arrow:
 *   • `down` = K-high (normal): rank ladder runs K, 9, 8, ... A.
 *   • `up`   = A-high (reversed): rank ladder runs A, 2, 3, ... K.
 * The Joker is always above either ladder; we don't try to encode that
 * here — the tooltip explains.
 */

import type { RegicidePublicState } from "../../../../shared/games/regicide.js";
import { TrumpBadge } from "../../components/TrumpBadge.js";

export function RegicideTrumpPanel({ state }: { state: RegicidePublicState }) {
  const suit = state.trumpSuit;
  const reversed = state.rankReversed;
  return (
    <TrumpBadge
      suit={suit ?? null}
      direction={reversed ? "up" : "down"}
      rankLetter={reversed ? "A" : "K"}
    />
  );
}
